import { DraftConfiguration, DraftState, Point } from '@/types';
import { isNumber } from '@/utils/isNumber';
import { getScaleAndFontSize } from '@/model/configuration/getScaleAndFontSize';
import { isDraftTextOrPlaceHolderTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { updateFontSize } from './helper/updateFontSize';

export interface Transformation {
  offset?: Point;
  rotation?: number;
  scale?: number;
}

export const setTransformationAction =
  ({ cid }: DraftConfiguration, { offset, rotation, scale }: Transformation) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (offset) {
      configuration.offset = offset;
    }
    if (isNumber(scale)) {
      if (isDraftTextOrPlaceHolderTextConfiguration(configuration)) {
        const { fontSize } = getScaleAndFontSize(
          configuration.text.style,
          configuration.rotation,
          configuration.size,
          configuration.printArea,
          configuration.printType,
          scale
        );

        updateFontSize(configuration, fontSize);
      } else {
        configuration.scale = scale;
      }
    }
    if (isNumber(rotation)) {
      configuration.rotation = rotation;
    }
  };
